module.exports = __webpack_public_path__ + "img/xqyc_10.58a76953.png";